import { render } from "./CloneConfigurator.vue?vue&type=template&id=8d0bd2d2"
import script from "./CloneConfigurator.vue?vue&type=script&lang=js"
export * from "./CloneConfigurator.vue?vue&type=script&lang=js"

import "./CloneConfigurator.vue?vue&type=style&index=0&id=8d0bd2d2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__